import styled from 'styled-components/macro';
import { keyframes } from 'styled-components';
import { IColors } from '../../interfaces';

interface IColor {
  colors: IColors;
}

const changeOpacity = keyframes`
  0% {opacity: 0.5}
  50% {opacity: 1}
  100% {opacity: 0.5}
`;

const changeWidthAndOpacity = keyframes`
  0% {width: 10vh; opacity: 0.5}
  50% {width: 15vh; opacity: 1}
  100% {width: 10vh; opacity: 0.5}
`;

const changeWidthAndOpacity2 = keyframes`
  0% {width: 30vh; opacity: 0.5}
  50% {width: 40vh; opacity: 1}
  100% {width: 30vh; opacity: 0.5}
`;

const changeWidthAndOpacity3 = keyframes`
  0% {width: 40vh; opacity: 0.5}
  50% {width: 50vh; opacity: 1}
  100% {width: 40vh; opacity: 0.5}
`;

export const Load = styled.div`
  transition: all 1s;
`;

export const LoadCont = styled.div<IColor>`
  width: 100%;
  border: none;
  border-radius: 5px;
  padding: 15px;
  margin-bottom: 5px;
  background-color: ${(props: any) => props.colors.cardColor};
  color: ${(props: any) => props.colors.fontColor};
`;

export const LoadHeader = styled.div`
  display: flex;
  justify-content: space-between;
  margin-bottom: 25px;
`;

export const LoadUser = styled.div`
  display: flex;
`;

export const LoadAvatar = styled.div<IColor>`
  border: none;
  border-radius: 50px;
  background-color: ${(props: any) => props.colors.background};
  width: 4vh;
  height: 4vh;
  margin-right: 5px;
  animation: ${changeOpacity} 2.5s infinite ease-in;
`;

export const LoadingName = styled.div<IColor>`
  border: none;
  border-radius: 50px;
  background-color: ${(props: any) => props.colors.background};
  height: 4vh;
  animation: ${changeWidthAndOpacity} 2.5s infinite ease-in-out;
`;

export const LoadingContent1 = styled.div<IColor>`
  border: none;
  border-radius: 50px;
  background-color: ${(props: any) => props.colors.background};
  width: 30vh;
  height: 4vh;
  margin-top: 5px;
  animation: ${changeWidthAndOpacity2} 2.5s infinite ease-in-out;
`;

export const LoadingContent2 = styled.div<IColor>`
  border: none;
  border-radius: 50px;
  background-color: ${(props: any) => props.colors.background};
  width: 40vh;
  height: 4vh;
  margin-top: 5px;
  animation: ${changeWidthAndOpacity3} 2.5s infinite ease-in-out;
`;
